export default __webpack_public_path__ + "static/media/dv2.ce949cd0.svg";